export default __webpack_public_path__ + "hero-pebble-black-friday-2.svg";